import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import HotelInfo from './HotelInfo/HotelInfo';
import ReviewInfo from './ReviewInfo/ReviewInfo';

import {ButtonBase} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {DETAIL_SEO_PAGES, getDetailSeoPageUrl} from '@stencil/hotels-utils/src/seo-utils';
import {useParams} from 'react-router-dom';
import {headingSizes} from '@stencil/build-theme';

export const OuterWrapperDiv = styled.section(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
`,
);

const HotelDetailsContainer = styled.section(
  props => `
  margin-top:1rem;
  margin-right:2rem;
`,
);

export const ViewRoomOptionsButton = styled(ButtonBase)(
  props => `
  margin-top: 1.2rem;
  padding: 1.6rem 6rem;
  height:4.7rem;
  width:100%;
  text-transform: none;
`,
);

export const BookHotelDiv = styled.div`
  ${headingSizes.Base}
`;

export default function HotelDetails({
  containerStyle = {},
  pageName = '',
  isSeoDetailPage = false,
  isSeoUnif = false,
  indianness = {},
}) {
  const params = useParams();

  const handleBookNowClick = () => {
    const pageUrl = getDetailSeoPageUrl('overview', params);
    window.open(pageUrl, '_self');
  };

  return (
    <OuterWrapperDiv style={containerStyle}>
      <HotelDetailsContainer>
        <HotelInfo
          isSeoDetailPage={isSeoDetailPage}
          isDetailReviews={pageName === DETAIL_SEO_PAGES.review}
          handleBookNowClick={handleBookNowClick}
          indianness={indianness}
        />
      </HotelDetailsContainer>
    </OuterWrapperDiv>
  );
}
